export enum LeadsPageKind {
  Leads = 0,
  LeadClients = 1,
}
